module.exports = __webpack_public_path__ + "static/img/11.9cb856f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/eng/11.png
// module id = 9v4e
// module chunks = 0